import OfflineIcon from './OfflineIcon';
import './OfflineNotice.css';

/** Banner for pages (or parts of them) that need a connection, shown while reading offline. */
const OfflineNotice: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="offlineNotice" role="status">
    <OfflineIcon size={18} />
    <span><strong>You're offline.</strong> {children}</span>
  </div>
);

export default OfflineNotice;
